import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/Toast";
import { ActionButton, actionLinkClasses } from "@/components/ui/ActionButton";
import type { Empresa } from "@/api/empresas";

interface EmpresaRowProps {
  empresa: Empresa;
  onDelete: (empresa: Empresa) => void;
}

export const EmpresaRow = ({ empresa, onDelete }: EmpresaRowProps) => (
  <>
    <td className="px-4 py-3 font-medium text-ink-primary">
      {empresa.razon_social}
    </td>
    <td className="px-4 py-3 num-font">{empresa.nit}</td>
    <td className="px-4 py-3 text-ink-secondary">
      {empresa.persona_contacto ?? empresa.email_contacto ?? "—"}
    </td>
    <td className="px-4 py-3 text-ink-secondary">{empresa.telefono ?? "—"}</td>
    <td className="px-4 py-3">
      <Badge variant={empresa.activa ? "success" : "danger"}>
        {empresa.activa ? "Activa" : "Inactiva"}
      </Badge>
    </td>
    <td className="px-4 py-3">
      <div className="flex justify-end gap-2">
        <Link
          to={`/empresas/${empresa.id}/editar`}
          className={actionLinkClasses("blue")}
          aria-label={`Editar ${empresa.razon_social}`}
        >
          Editar
        </Link>
        <ActionButton
          color="red"
          onClick={() => onDelete(empresa)}
          aria-label={`Eliminar ${empresa.razon_social}`}
        >
          Eliminar
        </ActionButton>
      </div>
    </td>
  </>
);